app.directive('assocAocrRefArboMission', ['crudService', '$filter', '$rootScope', '$timeout',
    function (crudService, $filter, $rootScope, $timeout) {
        return {
            restrict: "E",
            templateUrl: "/templates/partials/directives/forms/audit/assoc_aocr_ref_arbo_mission.html",
            scope: {
                observationId: '=',
                myDirectiveFn: '='
            },
            link: function (scope, element, attrs, tabsCtrl) {
                scope.loading = false;
                scope.associationsAvailables = [];
                scope.associationSelected = null;

                /**
                 * Selection d'une ligne assoc mission
                 * @param associationSelected
                 */
                scope.selectAssociationMission = function (associationSelected) {
                    scope.associationSelected = associationSelected;
                    scope.myDirectiveFn(scope.associationSelected.produit_id);
                    // Event du changement de produit : formModalFichierLevee@produitChange
                };

                let setLoading = function (loading) {
                    scope.loading = loading;
                };

                let getProduitsAvailables = function () {
                    setLoading(true);
                    scope.associationsAvailables = [];

                    crudService.get(
                        '/observations/' + scope.observationId + '/aocr-ref-arbos-missions',
                        {}
                    ).then(function (response) {
                        setLoading(false);

                        if (response.data) {
                            scope.associationsAvailables = response.data;

                            if (scope.associationsAvailables.length > 0) {
                                scope.selectAssociationMission(scope.associationsAvailables[0]);
                                // Selection par défaut du premier
                            }
                        }

                    }, function (error) {
                        setLoading(false);
                        // En cas d'erreur : CrudService ferme la modal avec un message d'erreur
                    });
                };

                scope.$watch('observationId', function (newValue, oldValue) {
                    if (newValue) {
                        getProduitsAvailables();
                    }
                }, true);
            }
        };
    }
]);
